import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import BinTrfIndexActions, { BinTrfIndexTypes } from '../Stores/BinTrfIndex/Actions';

const getAppStore = state => state.app;

export function* binTrfIndexFetchBinTrfIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(BinTrfIndexActions.binTrfIndexFetchBinTrfIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `binTrf/index/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        BinTrfIndexActions.binTrfIndexFetchBinTrfIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrfIndexActions.binTrfIndexFetchBinTrfIndexLoading(false));
  }
}

export function* binTrfIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/binTrfDetail/update/${hdrId}`));
}

export function* binTrfIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/BIN_TRF/${hdrId}/BinTrfHdr`));
}

export function* binTrfIndexNewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/binTrfDetail/create/${app.curSiteFlowId}`));
}

export function* binTrfIndexGoToPrint({ document }) {
  try {
    yield put(BinTrfIndexActions.binTrfIndexFetchBinTrfIndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `binTrf/print/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, `BinTrf_${document.doc_code}.pdf`);
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrfIndexActions.binTrfIndexFetchBinTrfIndexLoading(false));
  }
}

export const saga = [
  takeLatest(BinTrfIndexTypes.BIN_TRF_INDEX_GO_TO_DOCUMENT, binTrfIndexGoToDocument),
  takeLatest(BinTrfIndexTypes.BIN_TRF_INDEX_GO_TO_AUDIT, binTrfIndexGoToAudit),
  takeLatest(BinTrfIndexTypes.BIN_TRF_INDEX_NEW_DOCUMENT, binTrfIndexNewDocument),
  takeLatest(BinTrfIndexTypes.BIN_TRF_INDEX_FETCH_BIN_TRF_INDEX, binTrfIndexFetchBinTrfIndex),
  takeLatest(BinTrfIndexTypes.BIN_TRF_INDEX_GO_TO_PRINT, binTrfIndexGoToPrint)
];
